<script>
  import FlightEventHandler from './FlightEventHandler.svelte';
	import SignalLines from './signalLines'
</script>

<FlightEventHandler handlerClass={SignalLines} />